import { useMutation } from '@tanstack/react-query'
import { UserController } from 'src/controllers/user.controller'

const userController = new UserController()

export function useCheckEmail() {
  return useMutation<{ errorMessage?: string }, Error, string>({
    mutationKey: ['checkEmail'],
    mutationFn: (email: string) => userController.checkEmail(email)
  })
}
